import { z } from 'zod';
import { TZDate } from '@date-fns/tz';

export interface Snapshot {
    id: string;
    timestamp: Date;
    parentId: string;
}

export const snapshotSchema = z
    .object({
        id: z.string().uuid(),
        timestamp: z.coerce.date(),
        parentId: z.string().uuid(),
    })
    // we want this to allow other snapshot properties through
    .passthrough();

export const mockSnapshot = ({
    id = '145a32ec-73fc-44ce-a89f-0dbd69b34409',
    timestamp = new TZDate(new Date(), 'Australia/Perth'),
    parentId = 'bc807a03-6bd1-4a69-bd0a-360fcb77c578',
}: Partial<Snapshot> = {}): Snapshot => ({
    id,
    timestamp,
    parentId,
});
